import { useTranslation } from "react-i18next";

import type { Chase } from "@/campaigns/modules/chase/types";
import { wonRungCount } from "@/campaigns/modules/chase/types";
import { Typography } from "@/components/ui/typography";
import { formatEndDate } from "@/utils/format-end-date";

import { FinishedCampaignCard } from "./finished-campaign-card";

/**
 * Finished chase in the results grid: how many rungs the player won is the result when they won
 * any; otherwise the ended date, like the other types with no win to show.
 */
export const FinishedChaseCard = ({ chase }: { chase: Chase }) => {
  const { t } = useTranslation();
  const won = wonRungCount(chase);
  const ended = formatEndDate(chase.campaign.end);

  if (won > 0) {
    return (
      <FinishedCampaignCard campaign={chase.campaign}>
        <Typography tag="h5" className="text-prizes">
          {t("chase.wonPrizes", "You won {{count}} prizes", { count: won })}
        </Typography>
      </FinishedCampaignCard>
    );
  }

  return (
    <FinishedCampaignCard campaign={chase.campaign}>
      <Typography tag="h5" className="text-muted-foreground">
        {ended
          ? t("campaign.endedOn", "Ended {{date}}", { date: ended })
          : t("campaign.ended", "Ended")}
      </Typography>
    </FinishedCampaignCard>
  );
};
